import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';

import { cn } from '@/lib/utils';

type LinkOwnProps<C extends ElementType> = {
  component?: C;
  className?: string;
  children?: ReactNode;
};

export type LinkProps<C extends ElementType = 'a'> = LinkOwnProps<C> &
  Omit<ComponentPropsWithoutRef<C>, keyof LinkOwnProps<C>>;

/** Text link. Underlined, gx-highlight by default — override via `className`. */
export const Link = <C extends ElementType = 'a'>({
  component,
  className,
  ...props
}: LinkProps<C>) => {
  const Component = component ?? 'a';

  return (
    <Component
      className={cn('text-gx-highlight underline', className)}
      {...props}
    />
  );
};
